/*eslint no-use-before-define:0 *///TODO REMOVE THIS
var dd = require('ES/lib/dd');
var _ = require('ES/lib/lodash');
var React = require('ES/lib/react');
var radio = require('ES/lib/radio');
var RadioMixin = require('ES/utils/RadioMixin');

var FormMixin = require('ES/widgets/forms/FormMixin');
var ErrorAlert = require('ES/widgets/ErrorAlert');
var LoadingWrap = require('ES/widgets/LoadingWrap');
var HorizontalFields = require('ES/widgets/HorizontalFields');
var Modal = require('ES/widgets/Modal');

var AuthedUserSession = require('../../../../../utils/AuthedUserSession');
var Constants = require('../../../../../utils/Constants');

module.exports = dd.createClass({
	propTypes: {
		event: React.PropTypes.object.isRequired,
		Displaylists: React.PropTypes.object.isRequired,
		onClose: React.PropTypes.func.isRequired
	},
	mixins: [RadioMixin],
	getInitialState: function(){
		return {saving_custom_labels_for_sid: -1, error_msg: null};
	},
	componentWillMount: function(){
		var self = this;
		self.radio = {
			save_CustomFieldsLabels_succeeded: function(sid){
				if(self.state.saving_custom_labels_for_sid === sid){
					self.setState({saving_custom_labels_for_sid: -1, error_msg: null});
					self.props.onClose();
				}
			},
			'save_CustomFieldsLabels_failed': function(sid, message){
				if(self.state.saving_custom_labels_for_sid === sid){
					self.setState({saving_custom_labels_for_sid: -1, error_msg: 'Failed to save custom field labels: ' + message});
				}
			}
		};
	},
	__onSubmit: function(data){
		radio('save_CustomFieldsLabels').broadcast(data.speaker_id, data.company_id, data);
		this.setState({saving_custom_labels_for_sid: data.speaker_id, error_msg: null});
	},
	render: function(){
		var event = this.props.event;
		var Displaylists = this.props.Displaylists;
		var onClose = this.props.onClose;
		var is_saving = this.state.saving_custom_labels_for_sid > 0;

		return Modal({
				title: 'Custom Field Labels',
				onClose: is_saving ? null : onClose,
				buttons: []
			},
			LoadingWrap({is_loading: is_saving, text: 'Saving...'},
				ErrorAlert({message: this.state.error_msg}),
				CustomFieldLabelForm({
					Displaylists: Displaylists,
					initial_sid: _.first(event && event.sids),

					onSubmit: this.__onSubmit,
					onClose: onClose
				})
			)
		);
	}
});

var CustomFieldLabelForm = dd.createClass({
	mixins: [FormMixin],
	onFormChanged: function(field_path, new_value){
		if(field_path === 'speaker_id'){
			this._form_reset();//rebuild for the now selected speaker
		}
	},
	getInitialValues: function(props){
		var initial_sid = props.initial_sid;
		var Displaylists = props.Displaylists;
		var my_sids = AuthedUserSession.doIHaveAccess.admin.getSIDs();

		var sid = _.includes(my_sids, initial_sid) ? initial_sid : _.first(my_sids);
		if(this.state && this.state.data && this.state.data.speaker_id > 0){
			sid = this.state.data.speaker_id;
		}
		var speaker = _.first(_.filter(Displaylists && Displaylists.perspeaker, function(spkr){
			return sid == spkr.sid;
		}));
		var data = _.object(_.map(speaker && _.filter(speaker.customfieldlabels, function(elm) {
			// filter custom field labels by company id
			return _.parseInt(_.get(elm, ["coid"], _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"]))) === _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"]);
		}), function(elm){
			return [elm.id, elm.lbl];
		}));
		data.speaker_id = sid;
		data.company_id = _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"]);
		return data;
	},
	buildFields: function(){
		var Displaylists = this.props.Displaylists;

		var sids_I_can_manage = AuthedUserSession.doIHaveAccess.admin.getSIDs();
		var speakers_I_can_manage = _.filter(Displaylists && Displaylists.perspeaker, function(spkr){
			return _.includes(sids_I_can_manage, spkr.sid) && _.includes(spkr.companies, _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"]));
		});

		var schema = {
			speaker_id: {
				label: 'Speaker',
				type: 'select',
				options: _.object(_.map(speakers_I_can_manage, function(spkr){
					return [spkr.sid, spkr.name_full];
				}))
			}
		};
		_.each(_.range(0, Constants.QTYCUSTOMS).concat(_.range(100, 100 + Constants.QTYLONGCUSTOMS)), function(id){
			schema[id] = {
				label: (id >= 100 ? 'long' : 'short') + ' ' + (_.parseInt(id) + 1 + (id >= 100 ? -100 : 0)),
				type: 'text',
				validate: noopAlwaysTrue
			};
		});
		return schema;
	},
	render: function(){
		var fields = this.buildFields();
		var errors = this.state.errors || {};
		var onClose = this.props.onClose;


		return dd.form({className: 'form-horizontal', onSubmit: this._form_onSubmit},
			dd.div({className: 'alert alert-info'},
				dd.b(null, 'NOTE: '), 'Changes applied to these labels apply to ALL EVENTS and all OTHER USERS for this speaker.'
			),
			HorizontalFields({
				fields: fields,
				errors: errors,
				buildInput: this._form_buildInput,
				scale: 'sm',
				label_size: 2,
				layout: [
					['speaker_id', null]
				]
			}),
			dd.hr({}),
			dd.div(null,
				HorizontalFields({
					fields: fields,
					errors: errors,
					buildInput: this._form_buildInput,
					label_size: 2,
					layout: _.map(_.range(0, Constants.QTYCUSTOMS).concat(_.range(100, 100 + Constants.QTYLONGCUSTOMS)), function(id){
						return [id + ''];//must be a string
					})
				})
			),
			HorizontalFields.FormButtons({
				label_size: 2,
				scale: 'md',
				onCancel: onClose,

				right_align_buttons: true
			})
		);
	}
});

var noopAlwaysTrue = function(){
	return true;
};



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/custom/LabelEditorModal.js